import React from 'react';

import FormControl from 'components/FormControl';
import OptionSearchFilter from 'components/OptionSearchFilter';
import { ColorNames } from 'constants/colorNames';
import { NAICS_SEARCH } from 'graphql/company/queries';
import { SearchOptionsType } from 'interfaces/ISearchOptionsType';
import { IdName } from 'interfaces/IdName';
import { INaics } from 'interfaces/INaics';

import styles from './NaicsField.module.scss';

interface Props {
  rowLabel: string;
  label: string;
  isMultipleSelect: boolean;
  usage: 'findComps' | 'criteria';
  onChange: (selectedOptions?: IdName[], data?: any) => void;

  selectedItem?: SearchOptionsType;
  selectedItems?: SearchOptionsType[];
  itemsParser?: (items: INaics[]) => void;
}

export const NaicsField = ({
  rowLabel,
  label,
  isMultipleSelect,
  selectedItem,
  selectedItems,
  onChange,
  itemsParser,
  usage,
}: Props) => {
  const transformNaicsDataItems = (items: INaics[]) => {
    const transformedItems = items.map(i => ({
      id: i.id,
      name: `${i.fourDigitCode} - ${i.fourDigitName}`,
      twoDigitCode: i.twoDigitCode,
      twoDigitName: i.twoDigitName,
      fourDigitCode: i.fourDigitCode,
      fourDigitName: i.fourDigitName,
    }));

    return itemsParser?.(transformedItems) ?? transformedItems;
  };

  const styleMapper = {
    findComps: {
      wrapperClassName: styles['form-row'],
    },
    criteria: {
      labelWrapperClassName: styles['label-wrapper'],
      wrapperClassName: styles['form-row'],
      columnClassName: styles['column-wrapper'],
    },
  } as const;

  const styleProps = styleMapper[usage];

  return (
    <FormControl label={rowLabel} {...styleProps}>
      <OptionSearchFilter
        small
        hasBorder
        noMarginBottom
        gridColumnsCount={1}
        isMultipleSelect={isMultipleSelect}
        query={NAICS_SEARCH}
        {...(isMultipleSelect ? { selectedItems } : { selectedItem })}
        label={label}
        searchPlaceholder={label}
        variables={{ search: '' }}
        containerClassName={styles['input-container']}
        optionClassName={styles['dropdown-option']}
        backgroundContainerColor={ColorNames.ayWhiteColor}
        onChange={onChange}
        queryParser={data => transformNaicsDataItems(data?.naicsSearch ?? [])}
      />
    </FormControl>
  );
};
